var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircularCameraIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-228.391 -199.391)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 145",
    cx: 17,
    cy: 17,
    r: 17,
    transform: "translate(228.391 199.391)",
    style: {
      fill: "#fd7121"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 88"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 292",
    d: "M193.583 1853.227a3.96 3.96 0 1 0 3.96 3.96 3.964 3.964 0 0 0-3.96-3.96zm0 7.167a3.207 3.207 0 1 1 3.208-3.207 3.211 3.211 0 0 1-3.208 3.207z",
    transform: "translate(51.807 -1639.948)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 293",
    d: "M196.784 1845.932h-3.2l-.83-.9a2.4 2.4 0 0 0-1.773-.783H187.4a2.447 2.447 0 0 0-1.774.783l-.827.9h-1.319v-.594a.1.1 0 0 0-.1-.1h-1.48a.1.1 0 0 0-.1.1v.594h-.213a2.42 2.42 0 0 0-2.405 2.408v10.124a2.42 2.42 0 0 0 2.408 2.405h15.185a2.417 2.417 0 0 0 2.41-2.406v-10.125a2.419 2.419 0 0 0-2.401-2.406zm.966 2.408v10.122a.973.973 0 0 1-.969.966H181.6a.973.973 0 0 1-.969-.966v-10.12a.972.972 0 0 1 .966-.969h3.835l1.252-1.37a.989.989 0 0 1 .717-.317h3.578a.966.966 0 0 1 .71.314l1.26 1.373h3.833a.972.972 0 0 1 .968.967z",
    transform: "translate(56.201 -1636.166)",
    style: {
      fill: "#fff"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularCameraIcon);
export default __webpack_public_path__ + "static/media/circular-camera-icon.13caaebdcaafaa1713a17258a1a215f8.svg";
export { ForwardRef as ReactComponent };